/**
 * The GA payload for a breadcrumb link click, shared by the category and
 * taxonomy breadcrumb containers so the two cannot drift. They differ only in
 * how the event is dispatched: a hard navigation must await it before leaving
 * the page, a soft transition must not block on it.
 */
export const buildBreadcrumbClickEvent = ({
  destinationURL,
  linkDepth,
}: {
  destinationURL: string;
  linkDepth: number;
}) => ({
  event: 'custom_event',
  event_action: 'Link Click',
  event_category: 'Breadcrumb',
  event_label: `${linkDepth} Level(s) Up`,
  destination_URL: destinationURL,
});
